import { NgModule } from "@angular/core";
import { PopupLoaderModule, SharedModule } from "../../../../shared";
import { RebookSnoozeModalComponent } from "./rebook-snooze-modal.component";
import { MatButtonModule, MatDialogModule } from "@angular/material";

@NgModule({
  declarations: [RebookSnoozeModalComponent],
  imports: [
    SharedModule, PopupLoaderModule, MatDialogModule, MatButtonModule,
  ],
  entryComponents: [RebookSnoozeModalComponent],
})
export class RebookSnoozeModalModule { }